import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    options: {
      customProperties: true,
    },
    themes: {
      light: {},
      dark: {
        primary: "#F1FAEE",
        darkenText: "#A8DADC",
        secondary: "#2D8B8B",
        accent: "#3AA6A6",
        info: "#3AA6A6",
        success: "#10B981",
        warning: "#F59E0B",
        error: "#EF4D6A",
        background: "#1A2332",
        backgroundDarkn: "#223047",
      },
    },
  },

  rtl: true,
});
